import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'site-selection',
  templateUrl: './fn-site-selection.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnSiteSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
